<app-header />
<main class="overflow-x-hidden min-h-screen">
  <router-outlet />
</main>
<app-footer />
<app-whatsapp-fab />
